import Datepicker from "react-tailwindcss-datepicker";
import dayjs from "dayjs";
import { formatDateInUtcTimeZone } from "../../utils";
import { getPresetDateRanges } from "../../utils/dateRanges";
import FileTypeDropdown from "../dropdowns/fileTypeDropdown";

const GeneralFiltersGroup = ({
    rawValues,
    handleDateValueChange,
    handleFileTypesSelection,
    showDateFilter = true,
    showFileTypeFilter = true
}: {
    rawValues: any;
    handleDateValueChange: (value: any) => void;
    handleFileTypesSelection: (option: any) => void;
    showDateFilter?: boolean;
    showFileTypeFilter?: boolean;
}) => {
    if (!showDateFilter && !showFileTypeFilter) return null;
    const presetRanges = getPresetDateRanges();

    return (
        <div className="flex flex-col">
            <p className="text-lg text-blue-200">General</p>
            <div className="mt-1 flex flex-wrap items-center gap-4">
                {showDateFilter && (
                    <div className="z-40 w-[14rem] shrink-0">
                        <Datepicker
                            primaryColor={"blue"}
                            value={{
                                startDate: formatDateInUtcTimeZone(rawValues.assetModifiedAfter),
                                endDate: formatDateInUtcTimeZone(rawValues.assetModifiedBefore),
                            }}
                            onChange={handleDateValueChange}
                            placeholder={"Date Filter"}
                            containerClassName="relative w-full text-gray-700 datepicker-range-white"
                            inputClassName={
                                "placeholder:text-gray-700 text-sm font-medium leading-5 bg-white rounded-md focus:ring-0 w-full py-2 border-gray-300"
                            }
                            toggleClassName="text-gray-700 absolute right-0 h-full px-3 focus:outline-none"
                            showShortcuts={true}
                            configs={{
                                shortcuts: {
                                    last7Days: {
                                        text: "Last 7 days",
                                        period: {
                                            start: dayjs(presetRanges.last7Days?.startDate).toDate(),
                                            end: dayjs(presetRanges.last7Days?.endDate).toDate(),
                                        },
                                    },
                                    last30Days: {
                                        text: "Last 30 days",
                                        period: {
                                            start: dayjs(presetRanges.last30Days?.startDate).toDate(),
                                            end: dayjs(presetRanges.last30Days?.endDate).toDate(),
                                        },
                                    },
                                    thisYear: {
                                        text: "This Year",
                                        period: {
                                            start: dayjs(presetRanges.thisYear?.startDate).toDate(),
                                            end: dayjs(presetRanges.thisYear?.endDate).toDate(),
                                        },
                                    },
                                    last3Years: {
                                        text: "Last 3 Years",
                                        period: {
                                            start: dayjs(presetRanges.last3Years?.startDate).toDate(),
                                            end: dayjs(presetRanges.last3Years?.endDate).toDate(),
                                        },
                                    },
                                },
                            }}
                        />
                    </div>
                )}
                {showFileTypeFilter && (
                    <div className="z-40 w-[10rem] shrink-0">
                        <FileTypeDropdown
                            dropdownProps={{
                                selections: rawValues.fileTypes,
                                onOptionToggle: handleFileTypesSelection,
                                className: "w-[10rem] shrink-0",
                            }}
                        />
                    </div>
                )}
            </div>
        </div>
    );
};

export default GeneralFiltersGroup;
